/* wrap-refs-in-sup.js
   Cerca pattern [numero] dentro .fe_content e avvolge ogni occorrenza in <sup class="ref-sup">[n]</sup>
   Idempotente: non rielabora occorrenze già convertite.
*/
(function() {
  'use strict';
  var CONTAINER_SELECTOR = '.fe_product-description-wrapper';

  function wrapRefsIn(container) {
    if (!container) return;
    var re = /\[(\d+)\]/g;
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
    var node;
    var textNodes = [];

    while ((node = walker.nextNode())) {
      if (node.parentNode && node.parentNode.closest && node.parentNode.closest('.ref-sup')) continue;
      if (!node.nodeValue || !node.nodeValue.trim()) continue;
      textNodes.push(node);
    }

    textNodes.forEach(function(textNode) {
      var text = textNode.nodeValue;
      re.lastIndex = 0;
      var match;
      var lastIndex = 0;
      var frag = document.createDocumentFragment();
      var anyMatch = false;

      while ((match = re.exec(text)) !== null) {
        anyMatch = true;
        var idx = match.index;
        if (idx > lastIndex) {
          frag.appendChild(document.createTextNode(text.slice(lastIndex, idx)));
        }
        var sup = document.createElement('sup');
        sup.className = 'ref-sup';
        sup.textContent = match[0];
        frag.appendChild(sup);
        lastIndex = re.lastIndex;
      }

      if (!anyMatch) return;
      if (lastIndex < text.length) {
        frag.appendChild(document.createTextNode(text.slice(lastIndex)));
      }
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  function run() {
    var container = document.querySelector(CONTAINER_SELECTOR);
    if (!container) return;
    wrapRefsIn(container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.wrapRefsIn_fe_content = function() {
    var container = document.querySelector(CONTAINER_SELECTOR);
    wrapRefsIn(container);
  };
})();